import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const TextRotationAngleupIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"text_rotation_angleup"} ref={ref}/>
});

TextRotationAngleupIcon.displayName = "TextRotationAngleupIcon";
